<template>
  <div>
    <table-widget
      :items="items"
      :perPage="perPage"
      :totalRows="totalRows"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <!-- <template slot="buttons">
        <b-button v-if="manageCommunityPartners" class="mx-2" variant="primary" v-b-modal.community-partners-modal @click="selectedCommunityPartners = null"><font-awesome-icon icon="plus"/> Manage Community Partnerships</b-button>
      </template> -->
      <template slot="content">
        <b-table
          striped
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          show-empty
          small
        >
          <template v-slot:cell(name)="data">
            <a :href="partnerUrl + data.item.id" target="_blank">{{
              data.item.name
            }}</a>
          </template>
          <template v-slot:cell(type)="data">
            {{
              data.item.communityPartnerType
                ? data.item.communityPartnerType.name
                : ""
            }}
          </template>
          <template v-slot:cell(location)="data">
            {{ data.item.city }}, {{ data.item.state }}, {{ data.item.country }}
          </template>
          <template v-slot:cell(website)="data">
            <a target="_blank" :href="data.item.website">{{
              data.item.website
            }}</a>
          </template>
          <template v-slot:cell(details)="data">
            <a :href="partnerUrl + data.item.id" target="_blank">Details</a>
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import * as _ from "lodash";
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      form: {
        items: [],
      },
      fields: [
        { key: "name", label: "Name" },
        { key: "type", label: "Type" },
        { key: "location", label: "Location" },
        { key: "website", label: "Website" },
        { key: "details", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      showForm: false,
    };
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    manageCommunityPartners: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
  },

  components: {
    "table-widget": TableWidget,
  },

  computed: {
    partnerUrl: function () {
      return process.env.NODE_ENV !== "production"
        ? "https://communitypartnerships-dev.chs.asu.edu/community-partners/"
        : "https://communitypartnerships.chs.asu.edu/community-partners/";
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    displayItem(item) {
      return item.name;
    },
  },

  watch: {
    items: function () {
      if (this.items) {
        this.form.items = _.clone(this.items);
      }
    },
  },
  created() {
    if (this.items) {
      this.form.items = _.clone(this.items);
    }
  },
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}
table {
  font-size: 10pt;
}
</style>
